import { Badge, Box, IconButton, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { CartContext } from "../cart/index.js";
import { CartIcon } from "../icons";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import React from "react";
export const CartButton = ({ size = "medium" }) => {
    const { t } = useTranslation("c-common");
    const { cart } = React.useContext(CartContext);
    const theme = useTheme();
    const items = cart?.items.reduce((acc, item) => acc + item.quantity ?? 0, 0) ?? 0;
    const isTouchDevice = useMediaQuery("(hover: none)");
    const wrapWithTooltip = (n, title) => isTouchDevice ? (n) : (React.createElement(Tooltip, { arrow: true, color: "secondary", title: title }, n));
    return (React.createElement(Box, { sx: { display: "flex", alignItems: "center" } }, wrapWithTooltip(React.createElement(IconButton, { "aria-label": t("cart", "Warenkorb"), LinkComponent: Link, href: t("url-cart", "/warenkorb"), size: size, sx: { color: "inherit" } }, items > 0 ? (React.createElement(Badge, { anchorOrigin: { horizontal: "right", vertical: "bottom" }, badgeContent: items, color: "primary", overlap: "circular", sx: {
            "& .MuiBadge-badge": {
                lineHeight: 0.7,
                fontSize: "0.5em",
                fontWeight: "bold",
                [theme.breakpoints.up("md")]: {
                    lineHeight: 0.75,
                    fontSize: "0.4em",
                },
            },
        } },
        React.createElement(CartIcon, { fontSize: "small" }))) : (React.createElement(CartIcon, { fontSize: "small" }))), t("cart", "Warenkorb"))));
};
//# sourceMappingURL=cart-button.js.map